<template>
  <!-- start profile Practioner view -->
  <v-card class="pa-10 py-0" color="transparent" flat>
    <!-- Prfile Image -->
    <div class="d-flex align-center">
      <v-avatar size="100">
        <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
      </v-avatar>

      <h4 class="mx-5 index_head">{{ name }}</h4>
    </div>
    <!-- End profile  -->
    <!-- practioner Information -->
    <div class="mt-9">
      <v-row class="mt-2">
        <v-col cols="12" md="2">
          <div><span class="text-style-h1">ID</span></div>
          <div class="my-3">
            <span class="text-style-h1">Courses</span>
          </div>
          <div><span class="text-style-h1">Date at</span></div>
        </v-col>
        <v-col cols="12" md="4"
          ><div><span class="index_h1_text_style">#123</span></div>
          <div class="my-3"><span class="index_h1_text_style">28</span></div>
          <div><span class="index_h1_text_style">11/12/2021</span></div>
        </v-col>
        <v-col cols="12" md="2">
          <div><span class="text-style-h1"> Type user </span></div>
          <div class="my-3">
            <span class="text-style-h1"> Students</span>
          </div>
          <div><span class="text-style-h1">Invoices </span></div>
        </v-col>
        <v-col cols="12" md="4"
          ><div><span class="index_h1_text_style">Instructor</span></div>
          <div class="my-3"><span class="index_h1_text_style">1230</span></div>
          <div>
            <span class="index_h1_text_style"> 7</span>
            <span class="primary--text ml-1">(see invoices)</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12" md="2">
          <div><span class="text-style-h1">Email</span></div>
        </v-col>
        <v-col cols="12" md="10">
          <div>
            <span class="index_h1_text_style">bodytalkhoffmann@gmail.com</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- End  practioner Information -->
    <!--start Short Descrition -->
    <div class="mt-9">
      <div class="text-style-h1">Short description</div>
      <div class="mt-2">
        [little_description] Lorem ipsum dolor sit amet, consectetur adipiscing
        elit. Amet mi ornare lacus, augue. Rutrum adipiscing felis varius luctus
        venenatis velit sollicitudin. Id volutpat tristique viverra bibendum.
      </div>
    </div>
    <!--End Short Descrition -->
    <!--Start Specializations -->
    <div class="mt-9">
      <div class="text-style-h1">Specializations</div>
      <div class="mt-2">
        <v-chip color="#F7F8FC" label> Label1 </v-chip>
        <span class="px-1">
          <v-chip class="ma-1" color="#F7F8FC" label> Label2 </v-chip>
        </span>
        <v-chip color="#F7F8FC" label> Id </v-chip>
        <span class="px-1">
          <v-chip class="ma-1" color="#F7F8FC" label> nunc </v-chip>
        </span>
        <v-chip color="#F7F8FC" label> ipsum </v-chip>
        <span class="px-1">
          <v-chip class="ma-1" color="#F7F8FC" label> adipiscing </v-chip>
        </span>
        <v-chip color="#F7F8FC" label> sit </v-chip>
        <span class="px-1">
          <v-chip class="ma-1" color="#F7F8FC" label> urna </v-chip>
        </span>
        <v-chip color="#F7F8FC" label> viverra </v-chip>
        <v-chip color="#F7F8FC" label> suspendisse </v-chip>
        <span class="px-1">
          <v-chip class="ma-1" color="#F7F8FC" label> neque </v-chip>
        </span>
        <v-chip color="#F7F8FC" label> in </v-chip>
      </div>
      <!-- <div class="mt-1">
       <v-chip
            v-for="tag in tags"
            :key="tag"
            color="#F7F8FC" label
            class="py-4 px-1"
          >
          <span >
            {{ tag }}
            </span>
          </v-chip>
         </div> -->
    </div>
    <!--End Specializations -->
    <!--Start Loactions -->
    <div class="mt-9">
      <div class="text-style-head"><h5>Locations</h5></div>
      <div class="mt-2">
        <div class="d-flex my-6">
          <div class="d-flex">
            <div>
              <v-icon color="#D18911">mdi-map-marker</v-icon>
            </div>
            <div class="mx-3">
              <div class="index_h0 mt-1">Burmoos, 5111 Austria</div>
              <span class="index_h0" style="color: #d18911"
                >0676 6395 7271</span
              >
            </div>
          </div>
          <div class="d-flex mx-9">
            <div>
              <v-icon color="#D18911">mdi-map-marker</v-icon>
            </div>
            <div class="mx-3">
              <div class="index_h0 mt-1">Burmoos, 5111 Austria</div>
              <span class="index_h0" style="color: #d18911"
                >0676 6395 7271</span
              >
            </div>
          </div>
        </div>
        <div>
          <v-icon color="#D18911" style="font-size: 18px">mdi-email</v-icon>
          <span class="mx-3 index_h">bodytalkhoffmann@gmail.com</span>
        </div>
      </div>
      <!--End Loactions -->
      <!--Start Biography-->
      <div class="mt-9">
        <div class="text-style-head"><h5>Biography</h5></div>
        <div class="mt-2">
          <v-row class="mb-4 mt-2">
            <span class="index_text_style"
              >Todd Adkins PT, Adv. CBP, CBI and Angela Adkins LMT, Adv. CBP,
              CBI, CMI have over 45 years of combined experience in western
              medicine, mind-body therapies and holistic practices. Since 2002,
              Todd and Angela have owned and operated a successful holistic
              practice and international seminar business based in the
              Dallas/Ft. Worth area . Todd and Angela work with clients of all
              ages who seek optimal health and in partnership with a variety of
              professionals and health care providers.</span
            >
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="mb-4 mt-6">
            <span class="index_text_style"
              >Angela Adkins has over 20 years experience in the field of energy
              work and healing practices as a practitioner, licensed massage
              therapist and a business owner. She has facilitated MindScape
              courses for over 2,500 students in the United States, Japan,
              Brazil Todd Adkins PT, Adv. CBP, CBI and Angela Adkins LMT, Adv.
              CBP, CBI, CMI have over 45 years of combined experience in western
              medicine, mind-body therapies and holistic practices. Since 2002,
              Todd and Angela have owned and operated a successful holistic
              practice and international seminar business based in the
              Dallas/Ft. Worth area . Todd and Angela work with clients of all
              ages who seek optimal health and in partnership with a variety of
              professionals and health care providers.</span
            >
          </v-row>
        </div>
      </div>
      <!--End Biography-->
    </div> </v-card
  ><!--End main v-card-->
</template>

<script>
export default {
  name: "seemoreinfo",

  data() {
    return {
      infodialog: false,
      name: "[name_practitioner]",
      object: {
        ID: "110",
        Firstname: "Jane Doe",
        Email: "abc@demo.com",
        Role: "Admin",
      },
      tags: [
        "Work",
        "Home Improvement",
        "Vacation",
        "Food",
        "Drawers",
        "Shopping",
        "Art",
        "Tech",
        "Creative Writing",
      ],
      text: "Todd Adkins PT, Adv. CBP, CBI and Angela Adkins LMT, Adv. CBP, CBI, CMI have over 45 years of combined experience in western medicine, mind-body therapies and holistic practices. Since 2002,  Todd and Angela have owned and operated a successful holistic practice and international seminar business based in the Dallas/Ft. Worth area . Todd and Angela work with clients of all ages who seek optimal health and in partnership with a variety of professionals and health care providers.                                                                              Angela Adkins has over 20 years experience in the field of energy work and healing practices as a practitioner, licensed massage therapist and a business owner.  She has facilitated MindScape courses for over 2,500 students in the United States, Japan, Brazil Todd Adkins PT, Adv. CBP, CBI and Angela Adkins LMT, Adv. CBP, CBI, CMI have over 45 years of combined experience in western medicine, mind-body therapies and holistic practices. Since 2002,  Todd and Angela have owned and operated a successful holistic practice and international seminar business based in the Dallas/Ft. Worth area . Todd and Angela work with clients of all ages who seek optimal health and in partnership with a variety of professionals and health care providers.",
    };
  },
  methods: {
    closedialog() {
      this.close();
    },
  },
};
</script>
<!--style Sheet-->

<style scoped>
.index_head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;

  /* Black — High Emphasis */

  color: rgba(8, 8, 22, 0.87);
}

.index_h0 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #363636;
}
.index_h {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  color: #d18911;
}
.text-style-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;

  color: rgba(8, 8, 22, 0.87);
}
.text-style-h1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(34, 34, 34, 0.7);
}
.index_text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: rgba(8, 8, 22, 0.87);
}
</style>
